var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, clockAngle } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SvgRing } from './svg-ring';
import { SvgAnimatedCount } from './svg-animated-count';
var cls = classNames('svg-ring-chart');
export var SvgRingChartDefaultProps = {
  value: 50,
  maxValue: 100,
  padding: 0,
  springConfig: {
    duration: 800
  },
  radius: 60,
  strokeWidth: 12,
  maxValueLabel: {
    colors: {
      fill: 'canvas'
    }
  },
  colors: {
    stroke: 'strong-chrome'
  },
  maxRing: {
    colors: {
      stroke: 'canvas'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var RingStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MaxRingStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MaxLabelStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SvgRingChart',
  Container: styled.svg(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MaxRing: styled(SvgRing)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), MaxRingStyles),
  Ring: styled(SvgRing)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), RingStyles),
  Text: styled(SvgAnimatedCount)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), RingStyles),
  MaxLabel: styled.tspan(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MaxLabelStyles)
};
export var SvgRingChart = function (props) {
  var componentProps = useComponentProps(My.NAME, SvgRingChartDefaultProps, props);
  var className = componentProps.className,
    springConfig = componentProps.springConfig,
    style = componentProps.style,
    padding = componentProps.padding,
    animate = componentProps.animate,
    radius = componentProps.radius,
    maxRing = componentProps.maxRing,
    maxValue = componentProps.maxValue,
    colors = componentProps.colors,
    strokeWidth = componentProps.strokeWidth,
    value = componentProps.value,
    children = componentProps.children,
    maxValueLabel = componentProps.maxValueLabel;
  var totalRadius = radius + strokeWidth + padding;
  var origin = {
    cx: totalRadius,
    cy: totalRadius
  };
  var width = totalRadius * 2;
  var height = totalRadius * 2;
  var viewBox = "0 0 ".concat(width, " ").concat(height);
  var startAngle = clockAngle(0);
  var endAngle = clockAngle(359.9999);
  var valueEndAngle = clockAngle(360 * (value / (maxValue || 1)));
  var suffixProps = __assign({
    text: "/".concat(maxValue)
  }, maxValueLabel);
  return React.createElement(My.Container, {
    width: totalRadius * 2,
    height: totalRadius * 2,
    style: style,
    viewBox: viewBox,
    className: cls.name(className)
  }, React.createElement(My.MaxRing, {
    springConfig: springConfig,
    animate: animate,
    cx: origin.cx,
    cy: origin.cy,
    radius: radius,
    strokeWidth: strokeWidth,
    colors: maxRing.colors,
    startAngle: startAngle,
    endAngle: endAngle
  }), React.createElement(My.Ring, {
    springConfig: springConfig,
    cx: origin.cx,
    cy: origin.cy,
    radius: radius,
    animate: animate,
    strokeWidth: strokeWidth,
    colors: colors,
    startAngle: startAngle,
    endAngle: valueEndAngle,
    from: {
      endAngle: startAngle
    }
  }), React.createElement(My.Text, {
    animate: animate,
    springConfig: springConfig,
    x: origin.cx,
    y: origin.cy,
    value: value,
    suffix: suffixProps
  }, children));
};
SvgRingChart.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;